<template>
  <div>
    <under-input-sxs v-model.number="item.core.baseAttackBonus" maxlength="2">
      Base Attack Bonus
    </under-input-sxs>

    <under-text-sxs>
      <ez-modal-dice
        slot="underline"
        name="CMB"
        :dice="`1d20+${cmb}`">
        {{ cmb }}
      </ez-modal-dice>
      CMB
    </under-text-sxs>

    <under-text-sxs>
      <div slot="underline">{{ cmd }}</div>
      CMD
    </under-text-sxs>

    <under-text-sxs>
      <div slot="underline">{{ cmdFlatFooted }}</div>
      CMD Flat-Footed
    </under-text-sxs>

    <under-text-area-md v-model="item.core.languages" rows="2">
      Languages
    </under-text-area-md>

    <under-text-area-md v-model="item.core.proficiencies" rows="6">
      Proficiencies
    </under-text-area-md>
  </div>
</template>

<script>
import UnderInputSxs from "../shared/_UnderInputSxs.vue";
import UnderTextSxs from "../shared/_UnderTextSxs.vue";
import UnderTextAreaMd from "../shared/_UnderTextAreaMd.vue";
import EzModalDice from "@/components/shared/_VueEzModalDice.vue";

export default {
  name: "sections-base-values-pfrpg",
  components: {
    UnderInputSxs,
    UnderTextSxs,
    UnderTextAreaMd,
    EzModalDice
  },
  props: ["item"],
  computed: {
    // character: state => state.eb.character,
    cmb() {
      let bonus = 0;

      if (Number.isFinite(this.item.core.baseAttackBonus))
        bonus += this.item.core.baseAttackBonus;
      if (this.item.attributes.find(x => x.name === "strength"))
        bonus += this.$rpgv.d20.attributeBonus(
          this.item.attributes.find(x => x.name === "strength")
        );
      if (this.item.core.size)
        bonus += this.$rpgv.d20.size[this.item.core.size].modifier * -1;
      return bonus;
    },
    cmd() {
      let bonus = 10;
      if (Number.isFinite(this.item.core.baseAttackBonus))
        bonus += this.item.core.baseAttackBonus;
      if (this.item.attributes.find(x => x.name === "strength"))
        bonus += this.$rpgv.d20.attributeBonus(
          this.item.attributes.find(x => x.name === "strength")
        );
      if (this.item.attributes.find(x => x.name === "strength"))
        bonus += this.$rpgv.d20.attributeBonus(
          this.item.attributes.find(x => x.name === "dexterity")
        );
      if (this.item.core.size)
        bonus += this.$rpgv.d20.size[this.item.core.size].modifier * -1;
      return bonus;
    },
    cmdFlatFooted() {
      let bonus = 10;
      if (Number.isFinite(this.item.core.baseAttackBonus))
        bonus += this.item.core.baseAttackBonus;
      if (this.item.attributes.find(x => x.name === "strength"))
        bonus += this.$rpgv.d20.attributeBonus(
          this.item.attributes.find(x => x.name === "strength")
        );
      if (this.item.core.size)
        bonus += this.$rpgv.d20.size[this.item.core.size].modifier * -1;
      return bonus;
    }
  }
};
</script>
